import axios from 'axios';
import { takeEvery, call, put, select } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { HANDLE_API_CALLS, HANDLE_DELETED_VM, CLEAR_STATE, HANDLE_API_CALLS_PARTNER, HANDLE_SEED_API_CALLS, HANDLE_CREATE_API_CALLS, HANDLE_VM_LIST, HANDLE_VM_DETAILS, HANDLE_COHORTS_LIST, HANDLE_COHORTS_DETAILS, HANDLE_COHORTS_SEED_DATA, HANDLE_PATCH_COHORTS_BASIC, HANDLE_UPDATE_VM, HANDLE_UPLOAD_IMG_API, HANDLE_API_CALLS_CITY_DATA } from './constants';
import { setLoading } from '../Login/actions';
import { BASE_URL, BASE_URL_PARTNER } from '../../config/API';
// function that makes the api request and returns a Promise for response
const BASE_URL_2 = 'https://api-prod.daalchini.co.in';
const BASE_URL_PARTNER_2 = 'https://api-prod.daalchini.co.in/';
function callToAPI(method, url, data, { login }) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('url in saga   callToAPI======================================', url);
  return axios({
    method,
    url: `${BASE_URL}${url}`,
    data,
    headers: {
      'x-auth-token': (login && login.user && login.user.accessToken) || token
    }
  });
}
function callToAPI2(method, url, data, { login }) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('url in saga callToAPI2======================================', url);
  return axios({
    method,
    url: `${BASE_URL}${url}`,
    data,
    headers: {
      'x-auth-token': (login && login.user && login.user.accessToken) || token
    }
  });
}

function cretevmapi(method, url, data) {
  console.log('create vm saga fun 2');
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('ACCESS------->', token);
  return axios({
    method,
    url: `${BASE_URL_2}${url}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
function getCohortsSeedData(method, url, data) {
  console.log('create vm saga fun 2');
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('ACCESS------->', token);
  return axios({
    method,
    url: `${BASE_URL_2}${url}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

function seedcallToAPI(method, url) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('ACCESS------->', token);
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_2}${url}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

function getVmListAPI(method, url) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('ACCESS------->', token);
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_2}${url}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
function getCohortsListAPI(method, url) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('AC------->', token);
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_2}${url}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
function getVmDetailsAPI(method, url, id) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('ACCESS------->', id);
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_2}${url}${id}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
function getcohortsDetails(method, url, id) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  console.log('Details------>', id);
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_2}${url}${id}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
function callToPartnerAPI(method, url, data) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_PARTNER}${url}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
function cohortbasicpatchcallToPartnerAPI(method, url, data) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_PARTNER_2}${url}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

function UpdateVmToPartnerAPI(method, url, data) {
  const ls = localStorage.getItem('data');
  const token = ls ? JSON.parse(ls).accessToken : '';
  // console.log(params);
  return axios({
    method,
    url: `${BASE_URL_PARTNER_2}${url}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
function logoutUser() {
  localStorage.removeItem('data');
}

function* handlegetCohortsList(action) {
  console.log('url----------get vm list---------->', action.url);
  const state = yield select();
  try {
    const response = yield call(getCohortsListAPI, action.method, action.url, action.body, state);
    // console.log('response at saga ==> ', response);
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}

function* handleSeedCohortsDetails(action) {
  console.log('url------handleSeedCohortsDetails----getCohortsSeedData---------->', action.url);
  try {
    const response = yield call(getCohortsSeedData, action.method, action.url, action.body);
    console.log('response at saga  in handleSeedCohortsDetails fun ==> ', response);
    if (response) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}


function* handlegetVmListAPI(action) {
  console.log('url----------get vm list---------->', action.url);
  const state = yield select();
  try {
    const response = yield call(getVmListAPI, action.method, action.url, action.body, state);
    // console.log('response at saga ==> ', response);
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}
function* handleDeleteVmAPI(action) {
  console.log('dele------------->', action);
  const state = yield select();
  try {
    const response = yield call(getVmListAPI, action.method, action.url, action.body, state);
    console.log('dele response at saga de ==> ', response);
    if (response.status === 204) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('dele error-------------->', err.response.data.status.message);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', err.response.data.status.message);
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}
function* handlegetvmDetailsAPI(action) {
  console.log('url----------get vm list---------->', action.url);
  const state = yield select();
  try {
    const response = yield call(getVmDetailsAPI, action.method, action.url, action.id, state);
    console.log('response at saga ==> ', response);
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}


// worker saga: makes the api call when watcher saga sees the action
function* handleSeedAPICalls(action) {
  console.log('url-------------------->', action.url);
  const state = yield select();
  try {
    const response = yield call(seedcallToAPI, action.method, action.url, action.body, state);
    // console.log('response at saga ==> ', response);
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}


function* handleUploadImg(action) {
  console.log('image-------------------->', action);
  const state = yield select();
  try {
    const response = yield call(cretevmapi, action.method, action.url, action.body, state);
    /* console.log('response at saga ==> ', response); */
    if (action.handleSuccess) {
      toastr.success('SUCCESSFUL', 'IMAGE UPLOAD  SUCCESSFUL ');
    }
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to Upload');
      }
    }
  }
  return 0;
}

function* handleCreateVm(action) {
  console.log('url-------------------->', action);
  const state = yield select();
  try {
    const response = yield call(cretevmapi, action.method, action.url, action.body, state);
    console.log('create response ==> ', response);
    if (action.handleSuccess) {
      toastr.success('SUCCESSFUL', 'VM CREATED  SUCCESSFUL ');
    }
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    action.handleError(err.response);
    console.log('create vm error', err.response);
    if (err.response && err.response.status === 400) {
      toastr.error('Error', err.response.data.status.message);
    }
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');// yield call(logoutUser);
      /* yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/')); */
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
      /*  yield call(action.handleError, err.response); */
      }
    } else if (err.response.status === 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}


// worker saga: makes the api call when watcher saga sees the action
function* handleAPICallsCity(action) {
  console.log('url--------hand------------>', action.url);
  const state = yield select(); // get teh current state
  try {
    const response = yield call(callToAPI2, action.method, action.url, action.body, state);
    // console.log('response at saga ==> ', response);
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}

function* handleAPICalls(action) {
  const state = yield select(); // get teh current state
  console.log('action', action);
  try {
    const response = yield call(callToAPI, action.method, action.url, action.body, state);
    console.log('response at saga  DELE==> ', response);
    if (action.handleSuccess) {
      console.log('userlist working');
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('error', err.response.data.message);
    toastr.error('Error', err.response.data.message);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Failed to request');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}

function* handlePatchCohortsbasic(action) {
  const state = yield select(); // get teh current state
  try {
    const response = yield call(cohortbasicpatchcallToPartnerAPI, action.method, action.url, action.body, state);
    console.log('response at sagaTtt ==> ', response.data.success);
    if (response.data.success) {
      toastr.success('SUCCESSFUL', 'SUCCESSFUL UPDATED');
    }
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', err.response.data.message);
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}

function* handleUpdateVM(action) {
  const state = yield select(); // get teh current state
  try {
    const response = yield call(UpdateVmToPartnerAPI, action.method, action.url, action.body, state);
    console.log('responseError ==> ', response);
    if (response.status === 200) {
      toastr.success('SUCCESSFUL', 'SUCCESSFUL UPDATED');
    } if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    } if (response.status === 'false') {
      toastr.error('Error', 'tahzeeb');
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('SPERROR', err.response.data.status.message);
    console.error(err);
    if (err.response.status === 400) {
      toastr.error('ERROR', err.response.data.status.message);
      return err.response.status;
    } else if (err.response.status === 500) {
      toastr.error('ERROR', err.response.data.status.message);
      return err.response.status;
    } else if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', err.response.message);
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}
function* handleAPICallsPartner(action) {
  const state = yield select(); // get teh current state
  try {
    const response = yield call(callToPartnerAPI, action.method, action.url, action.body, state);
    // console.log('response at saga ==> ', response);
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('Search Emial Error----->', err.response.data.message);
    console.error(err);
    toastr.error('Error', err.response.data.message);
    /* if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', err.response.data.message);
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    } */
  }
  return 0;
}

function* handlegetcohortsDetailsAPI(action) {
  const state = yield select(); // get teh current state
  try {
    const response = yield call(getcohortsDetails, action.method, action.url, action.id, state);
    /* console.log('response at saga ==> ', response); */
    if (action.handleSuccess) {
      return yield call(action.handleSuccess, response.data.data);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err.response && err.response.status === 401) {
      toastr.error('Error', 'Please login to continue');
      yield call(logoutUser);
      yield put(setLoading(false));
      yield put({ type: CLEAR_STATE });
      yield put(push('/'));
    } else if (err.response && err.response.status === 404) {
      if (!action.showToast) {
        toastr.error('ERROR', 'Not found Invalid request!');
      }
      if (action.handleError) {
        yield call(action.handleError, err.response);
      }
    } else if (action.response !== 402) {
      if (!action.showToast) {
        toastr.error('ERROR', err.response.data.message);
      }
      if (action.handleError) {
        yield call(action.handleError, err.response.data);
      }
    }
  }
  return 0;
}

function* handleLogoutUser() {
  try {
    toastr.success('SUCCESSFUL', 'Logout successful');
    yield call(logoutUser);
    yield put(push('/'));
  } catch (err) {
    toastr.error('ERROR', 'Something went wrong');
  }
}

// watcher saga: watches for actions dispatched to the store, starts worker saga
function* callToAPIWatcher() {
  yield takeEvery(HANDLE_API_CALLS, handleAPICalls);
}
function* callToAPIWatcherCityData() {
  yield takeEvery(HANDLE_API_CALLS_CITY_DATA, handleAPICallsCity);
}
function* seedcallToAPIWatcher() {
  yield takeEvery(HANDLE_SEED_API_CALLS, handleSeedAPICalls);
}


function* vmDetailsToAPIWatcher() {
  yield takeEvery(HANDLE_VM_DETAILS, handlegetvmDetailsAPI);
}

function* cohortsDetailsToAPIWatcher() {
  yield takeEvery(HANDLE_COHORTS_DETAILS, handlegetcohortsDetailsAPI);
}

function* vmListToAPIWatcher() {
  yield takeEvery(HANDLE_VM_LIST, handlegetVmListAPI);
}
function* createVmcallToAPIWatcher() {
  yield takeEvery(HANDLE_CREATE_API_CALLS, handleCreateVm);
}
function* uploadImgToAPIWatcher() {
  yield takeEvery(HANDLE_UPLOAD_IMG_API, handleUploadImg);
}

function* callToAPIWatcherPartner() {
  yield takeEvery(HANDLE_API_CALLS_PARTNER, handleAPICallsPartner);
}
function* cohortsbasicupdateAPIWatcherPartner() {
  yield takeEvery(HANDLE_PATCH_COHORTS_BASIC, handlePatchCohortsbasic);
}
function* UpdateVmAPIWatcherPartner() {
  yield takeEvery(HANDLE_UPDATE_VM, handleUpdateVM);
}
function* userLogoutWatcher() {
  yield takeEvery(CLEAR_STATE, handleLogoutUser);
}

function* cohortsListToAPIWatcher() {
  yield takeEvery(HANDLE_COHORTS_LIST, handlegetCohortsList);
}

function* cohortsSeedDataToAPIWatcher() {
  yield takeEvery(HANDLE_COHORTS_SEED_DATA, handleSeedCohortsDetails);
}

function* DeleteVm() {
  yield takeEvery(HANDLE_DELETED_VM, handleDeleteVmAPI);
}

/* eslint-disable */
export { DeleteVm , callToAPIWatcher, userLogoutWatcher, callToAPIWatcherPartner,seedcallToAPIWatcher,createVmcallToAPIWatcher,vmListToAPIWatcher,vmDetailsToAPIWatcher,cohortsListToAPIWatcher,cohortsDetailsToAPIWatcher, cohortsSeedDataToAPIWatcher, cohortsbasicupdateAPIWatcherPartner,UpdateVmAPIWatcherPartner, uploadImgToAPIWatcher, callToAPIWatcherCityData};

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/Modules/HandleAPICalls/saga.js